/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonBreadcrumbUnder/view.blocks to change it.
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonBreadcrumbUnder({
  children,
  viewPath = "/DesignSystem/ButtonBreadcrumbUnder",
  onClick,
  text = "All Files"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="ButtonBreadcrumbUnder.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bbc-1-1Qs7Ho': isHovered ? "rgba(0,188,112, 1)" : "rgba(0,188,112, 0)"}}
 className={`views-block ${styles.Horizontal}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 text={text}
 color="#474747"
/>
</button>
{children}
</React.Fragment>)
}